import moment from 'moment';

interface IsDateValidParams {
  date: string;
  minDate?: Date;
  maxDate?: Date;
}

export const DATE_FORMAT = 'MM/DD/YYYY';

export const dateToString = (date: Date, dateFormat: string = DATE_FORMAT) =>
  moment(date).format(dateFormat);

export const stringToDate = (value: string, dateFormat: string = DATE_FORMAT) =>
  moment(value, dateFormat).toDate();

export const isDateValid = ({ date, minDate, maxDate }: IsDateValidParams) => {
  const momentDate = moment(date, 'M/D/YYYY', true);

  if (!momentDate.isValid()) {
    return false;
  }

  if (minDate && momentDate.isBefore(moment(minDate))) {
    return false;
  }

  return !(maxDate && momentDate.isAfter(moment(maxDate)));
};
